/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.events.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.printscreen.js" />
/// <reference path="skyward.ui.modallayer.js" />
/// <reference path="skyward.ui.changetracking.js" />
/// <reference path="skyward.ui.dailyAttendance.js" />
(
    function (skyward, $, undefined)
    {
        skyward.seatingchart = skyward.seatingchart || {};

        var init = function (selector)
        {
            var seatingChartContent = $(selector + " #seatingChartContent");
            if (seatingChartContent.length == 0)
            {
                return;
            }

            if (skyward.seatingchart.saveLayer)
            {
                skyward.seatingchart.saveLayer.close();
            }

            // General function declarations
            var defaultGridLineSizeValueX = 25;
            var defaultGridLineSizeValueY = 25;
            var gridLineSizeValueX;
            var gridLineSizeValueY;
            var snapToGridValue;
            var currentScaleX = 1;
            var currentScaleY = 1;

            var gridCssBuilder = function ()
            {
                canvas.css("background-size", "");
                canvas.css("background-image", "");

                var roomObjects = $(".roomObject");
                if (snapToGridValue)
                {
                    if (roomObjects.data("ui-draggable"))
                    {
                        roomObjects.each(function ()
                        {
                            var currRoomObject = $(this);
                            if (currRoomObject.data("ui-draggable"))
                            {
                                currRoomObject.draggable("option", "snap", "none");
                            };
                        });
                    }

                    var cutoffValueX = (100 / gridLineSizeValueX) * (gridLineSizeValueX - 1);
                    var cutoffValueY = (100 / gridLineSizeValueY) * (gridLineSizeValueY - 1);
                    canvas.css("background-size", gridLineSizeValueX + "px " + gridLineSizeValueY + "px");
                    canvas.css("background-image", "linear-gradient(0deg, transparent " + (cutoffValueX - 1) + "%, rgba(0, 0, 0, .05) " + cutoffValueX + "% ), linear-gradient( 90deg, transparent " + (cutoffValueY - 1) + "%, rgba(0, 0, 0, .05) " + cutoffValueY + "% )");
                    canvas.css("background-color", "#ffffff");
                }
                else
                {
                    if (roomObjects.data("ui-draggable"))
                    {
                        roomObjects.draggable("option", "snap", ".roomObjectPlaced");
                        roomObjects.draggable("option", "snapMode", "outer");
                        roomObjects.draggable("option", "snapTolerance", skyward.seatingchart.gridSnapTolerance);
                    }
                }
            };

            skyward.seatingchart.gridLineSize = function (xValue, yValue)
            {
                // Allow yValue to be optional (defaults to same as xValue)
                yValue = yValue || xValue;
                if (xValue <= 1 || yValue <= 1)
                {
                    snapToGridValue = false;
                }
                gridLineSizeValueX = xValue;
                gridLineSizeValueY = yValue;
                gridCssBuilder();
            };

            skyward.seatingchart.snapToGrid = function (value)
            {
                snapToGridValue = value;
                gridCssBuilder();
            };

            var registerRoomObjectDraggable = function (select, fromToolbox, revertFunction)
            {
                var draggableSettings =
                {
                    scroll: true,
                    helper: fromToolbox ? 'clone' : 'original',
                    start: function ()
                    {
                        if (!fromToolbox)
                        {
                            removeRoomObject.removeClass("removeRoomObjectHidden");
                            enableDiableStudentPopupClick(false);
                        }

                        var currRoomObject = $(this);
                        if (!currRoomObject.hasClass("ui-selected"))
                        {
                            unselectRoomObjects();
                            if (isRoomObjectPlaced(currRoomObject))
                            {
                                selectRoomObjects(currRoomObject);
                            }
                        }

                        getSelectedRoomObjects().each(function ()
                        {
                            var selectedObject = $(this);

                            var roomObjectStudents = selectedObject.find(".roomObjectStudents");
                            if (!isNullOrEmpty(roomObjectStudents) && !roomObjectStudents.hasClass("roomObjectStudentsDragging"))
                            {
                                roomObjectStudents.addClass("roomObjectStudentsDragging");
                            }

                            selectedObject.data("originalleft", parseInt(selectedObject.css("left"), 10));
                            selectedObject.data("originaltop", parseInt(selectedObject.css("top"), 10));
                        });

                    },
                    stop: function ()
                    {
                        if (!fromToolbox)
                        {
                            removeRoomObject.addClass("removeRoomObjectHidden");
                            // if we enable it right away then it will be called after this if they started dragging by the student images div
                            setTimeout(function () { enableDiableStudentPopupClick(true); }, 50); 
                        }

                        var resetOpactity = function (roomObject)
                        {
                            var roomObjectStudents = roomObject.find(".roomObjectStudents");
                            if (!isNullOrEmpty(roomObjectStudents) && roomObjectStudents.hasClass("roomObjectStudentsDragging"))
                            {
                                roomObjectStudents.removeClass("roomObjectStudentsDragging");
                            }
                        };

                        resetOpactity($(this));

                        $(".roomObject:not(.ui-draggable-dragging).ui-selected").each(function ()
                        {
                            var selectedObject = $(this);

                            resetOpactity(selectedObject);

                            selectedObject.removeData("originalleft");
                            selectedObject.removeData("originaltop");
                        });
                    },
                    drag: function (event, ui)
                    {
                        var currRoomObject = $(this);

                        var topRemainder = ui.position.top % (snapToGridValue
                            ? gridLineSizeValueY : ui.position.top);

                        var leftMarginAdjustmentPosition = parseInt(currRoomObject.css("marginLeft"), 10) + ui.position.left;
                        var leftRemainder = leftMarginAdjustmentPosition % (snapToGridValue
                            ? gridLineSizeValueX : leftMarginAdjustmentPosition);

                        var leftMarginScrollAdjust = 0;
                        var scrollLeftAdjust = 0;
                        var scrollTopAdjust = 0;
                        if (snapToGridValue && currRoomObject.hasClass("roomObjectList"))
                        {
                            scrollLeftAdjust = canvasScrollContainer.scrollLeft() % gridLineSizeValueX;
                            scrollTopAdjust = canvasScrollContainer.scrollTop() % gridLineSizeValueY;
                            leftMarginScrollAdjust = parseInt(canvasScrollContainer.css("marginLeft"), 10) % gridLineSizeValueX;
                        }

                        var topAjustedPosition = ui.position.top - topRemainder;
                        var leftAjustedPosition = leftMarginAdjustmentPosition - leftRemainder + leftMarginScrollAdjust;

                        ui.position.top = topAjustedPosition - scrollTopAdjust;
                        ui.position.left = leftAjustedPosition - scrollLeftAdjust;

                        var topDifference = ui.position.top - ui.originalPosition.top;
                        var leftDifference = ui.position.left - ui.originalPosition.left;

                        checkExpandCanvas(currRoomObject);

                        $(".roomObject:not(.ui-draggable-dragging).ui-selected").each(function ()
                        {
                            var currentObject = $(this);
                            currentObject.css("left", (currentObject.data("originalleft") + leftDifference) + "px");
                            currentObject.css("top", (currentObject.data("originaltop") + topDifference) + "px");
                            checkExpandCanvas(currentObject);
                        });
                    },
                    revert: revertFunction
                };

                if (!snapToGridValue)
                {
                    draggableSettings.snapTolerance = skyward.seatingchart.gridSnapTolerance;
                    draggableSettings.snapMode = "outer";
                    draggableSettings.snap = ".roomObjectPlaced";
                }

                initDraggable(select, draggableSettings);
            };

            var checkExpandCanvas = function (roomObject)
            {
                var canvasWidth = parseInt(canvas.css("width"), 10);
                var widthEdge = roomObject.position().left + parseInt(roomObject.css("width"), 10) + skyward.seatingchart.canvasEdgeBuffer;
                if (widthEdge > canvasWidth)
                {
                    canvas.css("width", widthEdge + "px");
                }

                var canvasHeight = parseInt(canvas.css("height"), 10);
                var heightEdge = roomObject.position().top + parseInt(roomObject.css("height"), 10) + skyward.seatingchart.canvasEdgeBuffer;
                if (heightEdge > canvasHeight)
                {
                    canvas.css("height", heightEdge + "px");
                }
            };

            var toolboxObjectRevertFunction = function ()
            {
                return function (valid)
                {
                    if (valid)
                    {
                        var roomObject = $(this);
                        var newSeat = roomObject.clone();

                        var draggable = roomObject.data("ui-draggable").helper;
                        var draggablePosition = draggable.position();

                        newSeat.css("top", (draggablePosition.top + canvasScrollContainer.scrollTop()) + "px");

                        var left = parseInt(draggablePosition.left, 10) + parseInt(draggable.css("marginLeft"), 10) + canvasScrollContainer.scrollLeft() - parseInt(canvasScrollContainer.css("marginLeft"), 10) - roomLayoutModeTab.width();
                        if (left < 0)
                        {
                            return true;
                        }

                        newSeat.css("left", left + "px");

                        newSeat.addClass("roomObjectPlaced");
                        newSeat.removeClass("roomObjectList");
                        newSeat.appendTo(canvas);

                        var createAction = createAddAction(newSeat);
                        addUndoAction(createAction);

                        registerRoomObjectDraggable(newSeat, false, canvasObjectRevertFunction(canvas));
                        skyward.seatingchart.dirtyScreen();
                        return false;
                    }
                    else
                    {
                        return true;
                    }
                };
            };

            var canvasObjectRevertFunction = function ()
            {
                return function (valid)
                {
                    var selectedObjects = $(".roomObject.ui-selected");

                    if (isNullOrEmpty(selectedObjects))
                    {
                        return false; 
					}

                    var deletedObjects = selectedObjects.filter(".roomObjectDeleted");
                    if (deletedObjects.length != 0)
                    {
                        // objects were dragged to the trash. revert the move so only the delete action is added
                        revertSelectedObjects(selectedObjects);
                        unselectRoomObjects(selectedObjects); 
                        return true;
                    }

                    if (valid)
                    {
                        var isValid = true;

                        var roomObjectPositionValid = function (canvasObject)
                        {
                            if (canvasObject.position().left < 0 || canvasObject.position().top < 0)
                            {
                                isValid = false;
                            }
                        };

                        if (isValid)
                        {
                            selectedObjects.each(function ()
                            {
                                roomObjectPositionValid($(this));
                                return isValid;
                            });
                        }

                        if (!isValid)
                        {
                            revertSelectedObjects();
                            return true;
                        }

                        var oldPositions = getRoomObjectPositions(selectedObjects, true);
                        var moveAction = createMoveAction(selectedObjects, oldPositions);
                        addUndoAction(moveAction);

                        skyward.seatingchart.dirtyScreen();
                        return false;
                    }
                    else
                    {
                        revertSelectedObjects();
                        return true;
                    }
                };
            };

            var registerCanvasObjectDroppable = function (select)
            {
                select.droppable(
                    {
                        accept: ".studentImage",
                        hoverClass: "roomObjectHover"
                    });
            };

            var registerStudentDraggable = function (select, revertFunction)
            {
                initDraggable(select,
                    {
                        // this creates a clone of the picture element which will also redownload the picture. not ideal
                        // depending on server speed this downloading is very noticable. 
                        // 'helper' can be a function that returns the element to be dragged and in that function we can do 
                        // a manual copy like this https://stackoverflow.com/a/39089081
                        helper: 'clone',
                        start: function ()
                        {
                            $(this).css("visibility", "hidden");
                        },
                        drag: function (event, ui)
                        {
                            if (ui.helper.css("cursor") !== "move")
                            {
                                ui.helper.css("cursor", "move");
                            }
                            var templateMargin = parseInt($(this).css("marginLeft"), 10);
                            ui.position.left = ui.position.left + templateMargin;
                        },
                        revert: revertFunction
                    });
            };

            /** Get the actual X value of the RoomObject (without applied scaling) */
            var getRoomObjectX = function (roomObject)
            {
                return Math.floor(parseInt(roomObject.css("left"), 10) / currentScaleX);
            };

            /** Get the actual Y value of the RoomObject (without applied scaling) */
            var getRoomObjectY = function (roomObject)
            {
                return Math.floor(parseInt(roomObject.css("top"), 10) / currentScaleY);
            };

            /** Get the actual width of the RoomObject (without applied scaling) */
            var getRoomObjectWidth = function (roomObject)
            {
                return roomObject.outerWidth(true) / currentScaleX;
            };

            /** Get the actual height of the RoomObject (without applied scaling) */
            var getRoomObjectHeight = function (roomObject)
            {
                return roomObject.outerHeight(true) / currentScaleY;
            };

            var appendStudentToSeat = function (student, seat, skipAutoScale)
            {
                var studentId = student.data("studentid");

                var previousSeat = $(".roomObjectSeat:has([data-studentid='" + studentId + "'])");
                var noOtherStudent = student.siblings("img:not([data-studentid='" + studentId + "'])").length == 0; 
                if (previousSeat.length && noOtherStudent)
                {
                    previousSeat.removeClass("roomObjectHasStudent");
                }

                seat.append(student);

                var labelContainer = $('#StudentListLabelContainer_' + studentId);
                if (labelContainer.length)
                {
                    seat.append(labelContainer);
                }

                var indicatorContainer = $('#StudentIndicatorContainer_' + studentId);
                if (indicatorContainer.length)
                {
                    seat.append(indicatorContainer);
                }

                if (!student.hasClass("studentImageSeated"))
                {
                    student.addClass("studentImageSeated");
                    student.removeClass("studentImageList");
                    var container = $("#StudentList_" + studentId);
                    if (container.length && !container.hasClass("studentInSeatingChart"))
                    {
                        container.addClass("studentInSeatingChart");
                        container.removeClass("assignFromStudentList");
                    }
                }

                if (!seat.hasClass("roomObjectHasStudent"))
                {
                    seat.addClass("roomObjectHasStudent");
                }

                student.css("visibility", "");

                if (skipAutoScale != true)
                {
                    autoScale();
				}

                checkUnassignedStudents();
            };

            var appendStudentToList = function (student)
            {
                var studentId = student.data("studentid");
                var container = $("#StudentList_" + studentId);
                if (container.length)
                {
                    container.removeClass("studentInSeatingChart");
                }
                else // Removing a student who is no longer in class
                {
                    container = $('<div/>');
                    container.attr('id', "#StudentList_" + studentId);
                    container.css('display', 'none');
                    $('#StudentList_body').append(container);
                }

                var previousSeat = $(".roomObjectSeat:has([data-studentid='" + studentId + "'])");
                var noOtherStudent = student.siblings("img:not([data-studentid='" + studentId + "'])").length == 0; 
                if (previousSeat.length && noOtherStudent)
                {
                    previousSeat.removeClass("roomObjectHasStudent");
                }

                container.append(student);
                student.css("visibility", "");

                var labelContainer = $('#StudentListLabelContainer_' + studentId);
                if (labelContainer.length)
                {
                    container.append(labelContainer);
                }

                var indicatorContainer = $('#StudentIndicatorContainer_' + studentId);
                if (indicatorContainer.length)
                {
                    container.append(indicatorContainer);
                }

                student.addClass("studentImageList");
                student.removeClass("studentImageSeated");

                autoScale();

                checkUnassignedStudents();
            };

            var studentRevertFunction = function ()
            {
                return function (valid)
                {
                    var student = $(this);
                    var revert = false; 

                    if (valid)
                    {
                        var studentId = student.data("studentid");
                        var location = $(valid);

                        if (location.hasClass("roomObjectSeat"))
                        {
                            var action;

                            if (location.has('.studentImageSeated:not([data-studentid="' + studentId + '"])').length)
                            {
                                var otherStudent = location.find(".studentImageSeated");
                                
                                if (student.hasClass("studentImageSeated"))
                                {
                                    // swapping student seats
                                    var currStudentDesk = $(".roomObjectPlaced").has(student);

                                    appendStudentToSeat(student, location, true);
                                    appendStudentToSeat(otherStudent, currStudentDesk, true);
                                    autoScale(); 

                                    action = createSwapAssignAction(student, location, otherStudent, currStudentDesk);
                                }
                                else
                                {
                                    // assigned from list to an assigned seat
                                    appendStudentToList(otherStudent);
                                    appendStudentToSeat(student, location);

                                    action = createAssignAction(student, location, otherStudent);
                                }
                            }
                            else
                            {
                                var currStudentDesk = $(".roomObjectPlaced").has(student);
                                var studentNotAlreadyAssigned = location.find('.studentImageSeated[data-studentid="' + studentId + '"]').length == 0;
                                // dragging to an empty seat or one the student is already in
                                appendStudentToSeat(student, location);
                                if (studentNotAlreadyAssigned)
                                {
                                    if (currStudentDesk.length > 0)
                                    {
                                        action = createMoveAssignAction(student, location, currStudentDesk);
                                    }
                                    else
                                    {
                                        action = createAssignAction(student, location, currStudentDesk);
                                    }
                                }
                            }
                            if (action)
                            {
                                addUndoAction(action);
                            }
                        }
                        else
                        {
                            appendStudentToList(student);
                        }
                    }
                    else
                    {
                        setTimeout(function () { student.css("visibility", ""); }, skyward.seatingchart.durationForRevert);
                        revert = true; 
                    }

                    if (revert == false)
                    {
                        skyward.seatingchart.dirtyScreen();
					}

                    return revert; 
                };
            };

            var initDraggable = function (select, config)
            {
                config.appendTo = config.appendTo || skyward.seatingchart.draggingAppendTo;
                config.revertDuration = config.revertDuration || skyward.seatingchart.durationForRevert;
                var origStartEvent = config.start;
                config.start = function (event, ui)
                {
                    if (origStartEvent)
                    {
                        //Need to set the proper context for the method call
                        origStartEvent.call(this, event, ui);
                    }
                    // This is to fix the position the draggable object reverts to
                    ui.originalPosition.left += parseInt($(this).css("marginLeft"), 10);
                };
                config.distance = skyward.seatingchart.distanceBeforeDragging;

                select.draggable(config);
            };

            var freezeCanvas = function ()
            {
                removeRoomObjectDraggableEvents($(".roomObject"));
                removeStudentDraggableEvents($(".studentImage"));

                removeSelectable();

                skyward.seatingchart.saveLayer = skyward.modalLayer.newModalLayer(null, null, {
                    closeOnClick: false,
                    closeOnRecordSelected: false,
                    closeOnEscape: false
                });
            };

            var unFreezeCanvas = function ()
            {
                if (roomLayoutModeTab && roomLayoutModeTab.hasClass("current"))
                {
                    roomLayoutModeTab.trigger("tabClicked");
                }
                else if (studentModeTab && studentModeTab.hasClass("current"))
                {
                    studentModeTab.trigger("tabClicked");
                }

                if (skyward.seatingchart.saveLayer)
                {
                    skyward.seatingchart.saveLayer.close();
                }
            };

            var roomLayoutSave = function ()
            {
                var roomLayoutData = [];

                var hasDeletes = false; 
                var roomObjects = $(".roomObjectPlaced, .roomObjectDeleted");
                roomObjects.each(function ()
                {
                    var roomObject = $(this);

                    var roomLayoutObjectId = roomObject.data("roomlayoutobjectid");
                    var roomObjectId = roomObject.data("roomobjectid");
                    var xLocation = getRoomObjectX(roomObject);
                    var yLocation = getRoomObjectY(roomObject);
                    var rotation = 0;
                    var isDelete = roomObject.hasClass("roomObjectDeleted");
                    if (isDelete && !hasDeletes)
                    {
                        hasDeletes = true; 
					}

                    roomLayoutData.push(
                        {
                            roomLayoutObjectId: roomLayoutObjectId,
                            roomObjectId: roomObjectId,
                            xLocation: xLocation,
                            yLocation: yLocation,
                            rotation: rotation,
                            isDelete: isDelete
                        });
                });

                if (hasDeletes && hasPendingDeletesThatHaveStudents)
                {
                    showWarningBanner(moduleContent);
                    return;
                }
                else
                {
                    hideWarningBanner(moduleContent); 
				}

                freezeCanvas();

                //Need to modify this to send the DisplayPeriodID, RoomID, and StaffID
                var roomLayoutSaveData =
                {
                    RoomLayoutObjectData: JSON.stringify(roomLayoutData),
                    RoomLayoutID: roomLayoutId
                };

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/RoomLayout/SaveRoomLayout/',
                        type: "POST",
                        dataType: "JSON",
                        data: roomLayoutSaveData,
                        error: function ()
                        {
                            skyward.seatingchart.saveLayer.close();
                            saveSeatingChartButton.on('click', seatingChartSaveButton);
                            unFreezeCanvas();
                        },
                        success: function (response)
                        {
                            if (!response.success)
                            {
                                skyward.seatingchart.saveLayer.close();
                                showErrorDialog("There was an error saving the Room Layout", response.Errors);
                                unFreezeCanvas();
                            }
                            else
                            {
                                saveSeatingChartButton.hide();
                                cancelSeatingChartButton.hide();
                                $.when(showSaveBanner(getCMAContainer()).done(function ()
                                {
                                    skyward.changeTracking.overrideGlobalDirtyState(false);
                                    skyward.window.reloadScreen();
                                }));
                            }
                        }
                    });
            };

            var seatingChartSave = function ()
            {
                var roomLayoutData = [];
                var seatingChartSeatData = [];

                var roomObjects = $(".roomObjectPlaced, .roomObjectDeleted");
                roomObjects.each(function ()
                {
                    var roomObject = $(this);

                    var roomLayoutObjectId = roomObject.data("roomlayoutobjectid");
                    var roomObjectId = roomObject.data("roomobjectid");
                    var xLocation = getRoomObjectX(roomObject);
                    var yLocation = getRoomObjectY(roomObject);
                    var rotation = 0;
                    var isDelete = roomObject.hasClass("roomObjectDeleted");
                    var studentId = null;

                    var student = roomObject.find(".studentImage");
                    if (student.length)
                    {
                        studentId = student.data("studentid");
                        seatingChartSeatData.push(
                            {
                                seatingChartSeatid: student.data("seatingchartseatid"),
                                originalRoomLayoutObjectId: student.data("originalroomlayoutobjectid"),
                                roomLayoutObjectId: roomLayoutObjectId,
                                studentId: studentId
                            });
                    }

                    roomLayoutData.push(
                        {
                            roomLayoutObjectId: roomLayoutObjectId,
                            roomObjectId: roomObjectId,
                            xLocation: xLocation,
                            yLocation: yLocation,
                            rotation: rotation,
                            isDelete: isDelete,
                            studentId: studentId
                        });
                });

                var studentListStudents = $(".studentImageList[data-seatingchartseatid]");
                studentListStudents.each(function ()
                {
                    var student = $(this);
                    var studentId = student.data("studentid");
                    var studentSeatingChartSeatId = student.data("seatingchartseatid");
                    if (studentSeatingChartSeatId)
                    {
                        seatingChartSeatData.push(
                            {
                                seatingChartSeatid: studentSeatingChartSeatId,
                                roomLayoutObjectId: null,
                                studentId: studentId
                            });
                    }
                });

                removeErrorBorder(getRoomObjects());

                freezeCanvas();

                //Need to modify this to send the DisplayPeriodID, RoomID, and StaffID
                var seatingChartSaveData =
                {
                    RoomLayoutObjectData: JSON.stringify(roomLayoutData),
                    SeatingChartSeatData: JSON.stringify(seatingChartSeatData),
                    DisplayPeriodID: displayPeriodId,
                    RoomID: roomId,
                    MeetID: meetId,
                    SeatingChartID: seatingChartId
                };

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/' + (saveObject ? saveObject : "SeatingChart") + '/SaveSeatingChart/',
                        type: "POST",
                        dataType: "JSON",
                        data: seatingChartSaveData,
                        error: function ()
                        {
                            skyward.seatingchart.saveLayer.close();
                            saveSeatingChartButton.on('click', seatingChartSaveButton);
                            unFreezeCanvas();
                        },
                        success: function (response)
                        {
                            if (!response.success)
                            {
                                skyward.seatingchart.saveLayer.close();
                                showErrorDialog("There was an error saving the Seating Chart", response.ErrorsHTML);
                                selectErroredRoomObjects(response.Errors);
                                unFreezeCanvas();
                            }
                            else
                            {
                                saveSeatingChartButton.hide();
                                cancelSeatingChartButton.hide();
                                $.when(showSaveBanner(getCMAContainer()).done(function ()
                                {
                                    skyward.changeTracking.overrideGlobalDirtyState(false);
                                    skyward.window.reloadScreen();
                                }));
                            }
                        }
                    });
            };

            var selectErroredRoomObjects = function (errors)
            {
                removeErrorBorder(getRoomObjects());

                if (errors == null || errors.length == 0)
                {
                    return; 
                }

                $.each(errors, function (fieldName, errors)
                {
                    if (fieldName)
                    {
                        var parts = fieldName.split("-");
                        if (parts.length >= 2 && parts[0] === "RoomLayoutObject" && parts[1])
                        {
                            var roomLayoutObjectID = parts[1];
                            var roomLayoutObject = getCanvasObjectsFromSelector(".roomObjectPlaced[data-roomlayoutobjectid='" + roomLayoutObjectID + "']");
                            if (!isNullOrEmpty(roomLayoutObject) && !roomLayoutObject.hasClass("roomObjectError"))
                            {
                                roomLayoutObject.addClass("roomObjectError")
                            }
                        }
                    }
                });
            };

            var isGeneralTabActive = function ()
            {
                return $("#tabGeneral.current").length > 0; 
            };

            var isPopupActive = function ()
            {
                return $(".popup").length > 0; 
            };

            var getCMAContainer = function ()
            {
                if (isInDetailsPanel)
                {
                    return seatingChartContentArea.parents(".contentArea");
                }
                else
                {
                    return moduleContent;
				}
            };

            var showSaveBanner = function (container)
            {
                var deferred = new $.Deferred();
                var cmaObject = getCMAObject(container);

                $('.contentMessageArea:not(#RoomLayoutObjectStudentsCMA)').on('SaveAnimationRedirect', function ()
                {
                    deferred.resolve();
                });

                cmaObject.setConfirmationMessage(skyward.contentMessageArea.getDefaultConfirmationMessage());
                cmaObject.showConfirmation();

                return deferred.promise();
            };

            var showWarningBanner = function (container)
            {
                hasPendingDeletesThatHaveStudents = false;

                var cmaObject = getCMAObject(container);
                cmaObject.setValidationCount(0, 1);
                cmaObject.showValidation();
            };

            var hideWarningBanner = function (container)
            {
                var cmaObject = getCMAObject(container);
                cmaObject.resetValidation();
            };

            var getCMAObject = function (container)
            {
                var cmaObject = skyward.contentMessageArea.getContentMessageArea(container);

                if (cmaObject == null)
                {
                    cmaObject = skyward.contentMessageArea.getContentMessageArea(container.parent());
                }

                if (cmaObject == null)
                {
                    cmaObject = skyward.contentMessageArea.getContentMessageArea($(".contentArea"));
                }

                return cmaObject; 
            };

            var seatingChartSaveButton = function ()
            {
                saveSeatingChartButton.off();
                $.when(saveObject == 'RoomLayout' ? roomLayoutSave() : seatingChartSave()).then(function ()
                {
                    saveSeatingChartButton.on("click", seatingChartSaveButton);
                });
            };

            var seatingChartCancel = function ()
            {
                freezeCanvas();
                skyward.changeTracking.overrideGlobalDirtyState(false);
                skyward.window.reloadScreen();
            };

            var seatingChartAddSeat = function ()
            {
                if (saveSeatingChartButton.is(":hidden"))
                {
                    var html = (displayMaxSeats ? "<span class='reference-slats static' style='width: 202px; max-width: 210px; margin: 0px; margin-left: 7px;'>" +
                        "<label class='slatLabel'>Maximum Number of Seats</label>" +
                        "<label class='slatData'>" + maxSeats + "</label></span>" : "") +
                        "<fieldset class='AddSeatFieldset'>" +
                        "<label class='title' data-validate-text-for='NumberOfRows'>Number of Rows: </label>" +
                        "<input id='NumberOfRows' class='text AddSeatTextbox' data-decimal-mask='99' data-validate-control-for='NumberOfRows'></input>" +
                        "</fieldset>" +
                        "<fieldset class='AddSeatFieldset'>" +
                        "<label class='title' data-validate-text-for='NumberOfColumns'>Number of Seats Per Row: </label>" +
                        "<input id='NumberOfColumns' class='text AddSeatTextbox' data-decimal-mask='99' data-validate-control-for='NumberOfColumns'></input>" +
                        "</fieldset>";

                    html.prepen
                    showMessageBoxAddSeat(html);
                }
                else
                {
                    showUnsavedChangesDialog($(this));
                }
            };

            var showMessageBoxAddSeat = function (html)
            {
                var messageBox;
                var saveButton = { text: "Save", "click": saveSeats, "icon": "Save" };
                var cancelButton = { text: "Cancel", "click": function () { messageBox.close(); }, "icon": "Cancel" };
                skyward.window.closePopup();
                messageBox = skyward.modalLayer.showDialog("Add Seats", html, [saveButton, cancelButton]);
                messageBox.container.css("min-width", "0px");
            };

            var saveSeats = function ()
            {
                var button = $(this);
                button.off('click');
                var baseStartingValue = 50;
                var rows = $('#NumberOfRows').val();
                var columns = $('#NumberOfColumns').val();

                var startingNumberColumn = 0;
                var startingNumberRow = 0;

                var roomObjects = $(".roomObjectPlaced");
                roomObjects.each(function ()
                {
                    var roomObject = $(this);

                    // The values we save must be transformed back to actual rather than scaled values
                    var xLocation = getRoomObjectX(roomObject);
                    var width = parseInt(roomObject.css("width"), 10);

                    var rowNumber = xLocation + width;
                    if (rowNumber > startingNumberRow)
                    {
                        startingNumberRow = rowNumber;
                    }

                    var yLocation = getRoomObjectY(roomObject);

                    if (startingNumberColumn == 0 || yLocation < startingNumberColumn)
                    {
                        startingNumberColumn = yLocation;
                    }
                });

                if (startingNumberColumn == 0)
                {
                    startingNumberColumn = baseStartingValue;
                }
                startingNumberRow += baseStartingValue;

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/RoomLayout/AddSeatingChartSeats/',
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            NumberOfRows: JSON.stringify(rows),
                            NumberOfColumns: JSON.stringify(columns),
                            RoomID: roomId,
                            RoomLayoutID: roomLayoutId,
                            StartingNumberColumn: startingNumberColumn,
                            StartingNumberRow: startingNumberRow,
                            SeatingChartId: seatingChartId
                        },
                        success: function (response)
                        {
                            if (!response.success)
                            {
                                button.on('click', saveSeats);
                                showErrorDialog("There was an error saving the Seating Chart", response.Errors);
                            }
                            else
                            {
                                skyward.window.skipUnloadCheck = true;
                                skyward.window.reloadScreen();
                            }
                        },
                        error: function ()
                        {
                            // skyward exception dialog is shown
                            button.on('click', saveSeats);
                        }
                    });
            };

            var seatingChartAssignStudents = function ()
            {
                if (saveSeatingChartButton.is(":hidden"))
                {
                    var html = '<fieldset><label class="title" data-for-id="AssignStudents_RadioButtonGroup">Assign Students By: </label><div id="AssignStudents_RadioButtonGroup" class="radioButtonGroup horizontal" data-name="AssignStudents"><label class="radioButton horizontal"><input type="radio" name="AssignStudentschild" value="First" checked="" class="horizontal radioButtonContent"><span class="radioButtonContent horizontal">First Name</span></label><label class="radioButton horizontal "><input type="radio" name="AssignStudentschild" value="Last" class="horizontal radioButtonContent"><span class="radioButtonContent horizontal">Last Name</span></label><label class="radioButton horizontal"><input type="radio" name="AssignStudentschild" value="Random" class="horizontal radioButtonContent"><span class="radioButtonContent horizontal">Random</span></label><input id="AssignStudents" class="radioButtonGroupValue" data-validate-control-for="AssignStudents" type="hidden" name="AssignStudents" data-original-value="First" value="First"></div></fieldset>';
                    html += '<fieldset><label class="title" data-for-id="AscendingOrder_RadioButtonGroup">Start: </label><div id="AscendingOrder_RadioButtonGroup" class="radioButtonGroup horizontal" data-name="AscendingOrder"><label class="radioButton horizontal"><input type="radio" name="AscendingOrderchild" value="ASC" checked="" class="horizontal radioButtonContent"><span class="radioButtonContent horizontal">Top Left</span></label><label class="radioButton horizontal"><input type="radio" name="AscendingOrderchild" value="DESC" class="horizontal radioButtonContent"><span class="radioButtonContent horizontal">Bottom Right</span></label><input id="AscendingOrder" class="radioButtonGroupValue" data-validate-control-for="AscendingOrder" type="hidden" name="AscendingOrder" data-original-value="ASC" value="ASC"></div></fieldset>';

                    showMessageBoxAddStudents(html);
                }
                else
                {
                    showUnsavedChangesDialog($(this));
                }
            };

            var showUnsavedChangesDialog = function (button)
            {
                var message = "There are unsaved changes on the seating chart.  Please save or cancel before continuing.";
                var options =
                {
                    anchorTo: button,
                    id: "UnsavedSeatingChart",

                };
                var closeButton = { id: "closeUnsavedSeatingChartPopup", text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var dialog = skyward.modalLayer.showDialog('Unsaved Changes', message, [closeButton], options);
                event.stopPropagation();
                return;
            }

            var showErrorDialog = function (message, errorMessageContent)
            {
                var errorContentHtml = message + "<br><br>" + errorMessageContent.Content;

                skyward.modalLayer.showCriticalDialog("Error", errorContentHtml);
            };

            var showMessageBoxAddStudents = function (html)
            {
                var messageBox;
                var saveButton = { text: "Save", "click": assignStudents, "icon": "Save" };
                var cancelButton = { text: "Cancel", "click": function () { messageBox.close(); }, "icon": "Cancel" };
                skyward.window.closePopup();
                messageBox = skyward.modalLayer.showDialog("Auto Assign Seats", html, [saveButton, cancelButton]);
            };

            var assignStudents = function ()
            {
                var button = $(this);
                button.off('click');
                var radioGroupValue = $('#AssignStudents').val();
                var ascendingOrderGroupValue = $('#AscendingOrder').val();
                var roomLayoutData = [];
                var seatingChartSeatData = [];

                removeErrorBorder(getRoomObjects());

                var roomObjects = $(".roomObjectPlaced.roomObjectSeat, .roomObjectDeleted.roomObjectSeat");
                roomObjects.each(function ()
                {
                    var roomObject = $(this);

                    var roomLayoutObjectId = roomObject.data("roomlayoutobjectid");
                    var roomObjectId = roomObject.data("roomobjectid");
                    var xLocation = getRoomObjectX(roomObject);
                    var yLocation = getRoomObjectY(roomObject);
                    var rotation = 0;
                    var isDelete = roomObject.hasClass("roomObjectDeleted");
                    var studentId = null;

                    var student = roomObject.find(".studentImage");
                    if (student.length)
                    {
                        studentId = student.data("studentid");
                        seatingChartSeatData.push(
                            {
                                seatingChartSeatid: student.data("seatingchartseatid"),
                                roomLayoutObjectId: roomLayoutObjectId,
                                studentId: studentId
                            });
                    }

                    roomLayoutData.push(
                        {
                            roomLayoutObjectId: roomLayoutObjectId,
                            roomObjectId: roomObjectId,
                            xLocation: xLocation,
                            yLocation: yLocation,
                            rotation: rotation,
                            isDelete: isDelete,
                            studentId: studentId
                        });
                });

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + 'Attendance/SeatingChart/AssignSeatingChartSeats/',
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            RadioGroupValue: radioGroupValue,
                            AscendingOrderGroupValue: ascendingOrderGroupValue,
                            RoomLayoutObjectData: JSON.stringify(roomLayoutData),
                            SeatingChartSeatData: JSON.stringify(seatingChartSeatData),
                            RoomID: roomId,
                            SeatingChartId: seatingChartId
                        },
                        success: function (response)
                        {
                            if (!response.success)
                            {
                                button.on('click', assignStudents);
                                showErrorDialog("There was an error saving the Seating Chart", response.ErrorsHTML);
                                selectErroredRoomObjects(response.Errors);
                            }
                            else
                            {
                                skyward.window.loadContent('full', 'Attendance', 'SeatingChart', 'Details', seatingChartId, { tab: "tabGeneral", "RoomID": roomId, "screenObject": "SeatingChart" });
                                skyward.window.skipUnloadCheck = true;
                            }
                        },
                        error: function ()
                        {
                            // skyward exception dialog is shown
                            button.on('click', assignStudents);
                        }
                    });
            };

            var seatingChartGridCheckbox = function ()
            {
                if (this.checked)
                {
                    skyward.seatingchart.snapToGrid(true);
                    gridIncreaseButton.css("display", "");
                    gridDecreaseButton.css("display", "");
                }
                else
                {
                    skyward.seatingchart.snapToGrid(false);
                    gridIncreaseButton.css("display", "none");
                    gridDecreaseButton.css("display", "none");
                }
            };

            var seatingChartGridIncrease = function ()
            {
                if (gridLineSizeValueX < skyward.seatingchart.gridLineMaxSize && gridLineSizeValueY < skyward.seatingchart.gridLineMaxSize)
                {
                    skyward.seatingchart.gridLineSize(gridLineSizeValueX * 2, gridLineSizeValueY * 2);
                }
            };

            var seatingChartGridDecrease = function ()
            {
                if (gridLineSizeValueX > skyward.seatingchart.gridLineResizeStep && gridLineSizeValueY > skyward.seatingchart.gridLineResizeStep)
                {
                    skyward.seatingchart.gridLineSize(gridLineSizeValueX / 2, gridLineSizeValueY / 2);
                }
            };

            var selectNewSeatingChart = function ()
            {
                var seatingChartData = $("#seatingChartData");
                var displayPeriodId = seatingChartData.data("displayperiodid");
                var roomId = seatingChartData.data("roomid");
                var seatingChartAction = "select";

                var selectSeatingChartsSaveData =
                {
                    DisplayPeriodID: displayPeriodId,
                    RoomID: roomId,
                    MeetID: meetId,
                    CurrentSeatingChartID: seatingChartId
                };

                var buildSelectNewSeatingChartPopup = function ()
                {
                    var seatingChartDescription = $("#seatingChartDescription").val();
                    selectSeatingChartsSaveData.Description = seatingChartDescription;

                    return $.ajax({
                        url: skyward.global.virtualDir + 'Attendance/SeatingChartMeet/SelectSeatingChartPopup/',
                        type: "POST",
                        dataType: "viewparthtml",
                        data: selectSeatingChartsSaveData
                    });
                };

                var saveButton =
                {
                    id: "saveNewSeatingChart",
                    text: "Save",
                    click: function ()
                    {
                        var seatingChartID = skyward.controls.getValue(dialog.content.find('#SelectSeatingChartEEL'));
                        var seatingChartNameSaveData =
                        {
                            SeatingChartAction: seatingChartAction,
                            SeatingChartID: seatingChartID,
                            DisplayPeriodId: displayPeriodId,
                            RoomID: roomId
                        };

                        return $.ajax(
                            {
                                url: skyward.global.virtualDir + 'Attendance/SeatingChartMeet/SelectSeatingChart/',
                                type: "POST",
                                dataType: "JSON",
                                data: seatingChartNameSaveData,
                                success: function (response)
                                {
                                    if (!response.success)
                                    {
                                        var container = $('.messageBox.content');
                                        var baseErrorContainer = container.find("#SelectSeatingChartError");

                                        skyward.validation.displayValidationMessages(response, container, baseErrorContainer);
                                    }
                                    else
                                    {
                                        location.reload();
                                        dialog.close();
                                    }
                                }
                            });
                    },
                    icon: "Save"
                };
                var cancelButton =
                {
                    id: "cancelNewSeatingChart",
                    text: "Cancel",
                    click: function ()
                    {
                        dialog.close();
                    },
                    icon: "Cancel"
                };
                var options =
                {
                    width: 550
                };
                var dialog = skyward.modalLayer.showDialog("Select Seating Chart", buildSelectNewSeatingChartPopup, [saveButton, cancelButton], options);
            };

            var attachListeners = function ()
            {
                $(window).resize(canvasResize);

                saveSeatingChartButton.off().on("click", seatingChartSaveButton);
                cancelSeatingChartButton.off().on("click", seatingChartCancel);
                addSeatSeatingChartButton.off().on("click", seatingChartAddSeat);

                if (isSeatingChartDetails && getRoomObjects().length == 0 && assignStudentsSeatingChartButton.length > 0)
                {
                    skyward.controls.disable(assignStudentsSeatingChartButton);
                }
                else
                {
                    assignStudentsSeatingChartButton.off().on("click", seatingChartAssignStudents);
				}

                gridEnableCheckbox.change(seatingChartGridCheckbox);
                // Ensure the initial visibility of the grid is correct
                seatingChartGridCheckbox.call(gridEnableCheckbox[0] /* seatingChartGridCheckbox expects "this" to be a DOMElement, not $ */);

                gridIncreaseButton.off().on("click", seatingChartGridIncrease);
                gridDecreaseButton.off().on("click", seatingChartGridDecrease);

                selectNewSeatingChartButton.off().on("click", selectNewSeatingChart);

                if (displayIndicators && displayIndicators.length > 0)
                {
                    displayIndicators.change(toggleIndicators);
                }

                if (isRoomLayoutDetails)
                {
                    enableDiableStudentPopupClick(true);
                    $(window).on("keydown", roomLayoutKeyDown);
                }

                if (isRoomLayoutDetails || isSeatingChartDetails)
                {
                    canvas.mouseup(canvasClicked);

                    undoButton.click(undo);
                    redoButton.click(redo);

                    $(window).keyup(function ()
                    {
                        pressedKey = null;
                    });
                }

                if (isSeatingChartDetails)
                {
                    $(window).keydown(seatingChartKeyDown);
                    $(".roomObjectPlaced").hover(roomObjectMouseEnter, roomObjectMouseLeave);
                    checkUnassignedStudents();

                    $(window).contextmenu(canvasContextMenu);
                }

                if (isSeatingChartDetails || isDailyAttendance)
                {
                    attachStudentInfoClick(seatingChartContent);
                }

               
            };

            var enableDiableStudentPopupClick = function (enable)
            {
                if (enable)
                {
                    seatingChartContent.find(".roomObjectStudents").on("click", roomLayoutDetailsStudentsClick);
                }
                else
				{
                    seatingChartContent.find(".roomObjectStudents").off("click");
				}
            };

            var setScale = function (scaleX, scaleY)
            {
                $(selector + ' .roomObjectPlaced').each(function ()
                {
                    var objectToScale = $(this);
                    var newTop = Math.round((getRoomObjectY(objectToScale) * scaleY));
                    var newLeft = Math.round((getRoomObjectX(objectToScale) * scaleX));

                    this.style.width = (getRoomObjectWidth(objectToScale) * scaleX) + 'px';
                    this.style.height = (getRoomObjectHeight(objectToScale) * scaleY) + 'px';
                    this.style.left = newLeft + 'px';
                    this.style.top = newTop + 'px';
                });

                // The canvas also needs to be resized to ensure all the scaled desks fit on it
                canvasResize();
                // Grid must be reset and adjusted for the new scale values
                skyward.seatingchart.gridLineSize(defaultGridLineSizeValueX * scaleX, defaultGridLineSizeValueY * scaleY);

                // This happens last, as getRoomObjectX/Y depend currentScaleX/Y not being updated to newly passed in values
                currentScaleX = scaleX;
                currentScaleY = scaleY;
            };

            var autoScale = function ()
            {
                // measure every desk
                var placedDesks = $(selector + ' .roomObjectPlaced.roomObjectSeat');

                // No need to scale if there's nothing to scale
                if (placedDesks.length === 0)
                {
                    return;
                }

                var measureSelector = '.studentIndicatorContainer,label,.seatingChartAttendanceDropdownContainer,.seatingChartAttendanceRadioButtonContainer';
                var maxTotalHeight = 0;

                // Assumes every student desk is the same height
                var studentDeskHeight = getRoomObjectHeight(placedDesks.eq(0));

                placedDesks.each(function ()
                {
                    var totalHeight = 0;
                    $(this).find(measureSelector).not(".roomObjectOfficeLabel,.radioButton.vertical").each(function ()
                    {
                        var toMeasure = $(this);
                        totalHeight += toMeasure.outerHeight(true);
                    });

                    if (totalHeight > maxTotalHeight)
                    {
                        maxTotalHeight = totalHeight;
                    }
                });

                var calculatedScaleFactor = maxTotalHeight / studentDeskHeight;
                // Currently, only scale up from original values, never down (downscaling not needed to fit indicators)
                if (calculatedScaleFactor < 1)
                {
                    calculatedScaleFactor = 1;
                }
                setScale(1, calculatedScaleFactor);
            };

            skyward.seatingchart.dirtyScreen = function ()
            {
                skyward.seatingchart.setDirtyState(true);
            };

            skyward.seatingchart.setDirtyState = function (isDirty)
            {
                if (isDirty)
                {
                    if (saveSeatingChartButton.is(":hidden"))
                    {
                        saveSeatingChartButton.show();
                    }
                    if (cancelSeatingChartButton.is(":hidden"))
                    {
                        cancelSeatingChartButton.show();
                    }
                }
                else
                {
                    if (!saveSeatingChartButton.is(":hidden"))
                    {
                        saveSeatingChartButton.hide();
                    }
                    if (!cancelSeatingChartButton.is(":hidden"))
                    {
                        cancelSeatingChartButton.hide();
                    }
                }
                skyward.changeTracking.overrideGlobalDirtyState(isDirty);
            };

            var removeStudentDraggableEvents = function (studentImages)
            {
                if (studentImages.data("ui-draggable"))
                {
                    studentImages.each(function ()
                    {
                        var currStudentImage = $(this);
                        if (currStudentImage.data("ui-draggable"))
                        {
                            currStudentImage.draggable("destroy");
                        }
                    });
                }
            };

            var removeRoomObjectDraggableEvents = function (roomObjects)
            {
                if (roomObjects.data("ui-draggable"))
                {
                    roomObjects.each(function ()
                    {
                        var currRoomObject = $(this);
                        if (currRoomObject.data("ui-draggable"))
                        {
                            currRoomObject.draggable("destroy");
                        }
                    });
                }
            };

            var removeSelectable = function ()
            {
                if (canvas.data("ui-selectable"))
                {
                    canvas.selectable("destroy");
                    $(".ui-selectee").removeClass("ui-selectee");
                    $(".ui-selected").removeClass("ui-selected");
                    $(".ui-selecting").removeClass("ui-selecting");

                    var selectBox = $(".ui-selectable-helper");
                    if (selectBox.length)
                    {
                        selectBox.remove();
                    }
                }
            };

            var canvasResize = function ()
            {
                var canvasWidth = 0;
                var canvasHeight = 0;

                $(".roomObjectPlaced").each(function ()
                {
                    var currRoomObject = $(this);
                    var widthEdge = parseInt(currRoomObject.css("left"), 10) + parseInt(currRoomObject.css("width"), 10);

                    if (widthEdge > canvasWidth)
                    {
                        canvasWidth = widthEdge;
                    }

                    var heightEdge = parseInt(currRoomObject.css("top"), 10) + parseInt(currRoomObject.css("height"), 10);
                    if (heightEdge > canvasHeight)
                    {
                        canvasHeight = heightEdge;
                    }
                });

                var seatingChartContent = $("#seatingChartContent");

                if (seatingChartContent.length && moduleContent.length)
                {
                    var containerWidth = parseInt(canvasScrollContainer.css("width"), 10);
                    // Need to get the height relative to moduleContent because on save or cancel reload, it does not size correctly
                    var containerHeight = parseInt(moduleContent.css("height"), 10) - seatingChartContent.position().top;

                    if (canvasWidth < containerWidth)
                    {
                        canvasWidth = containerWidth;
                    }
                    if (canvasHeight < containerHeight)
                    {
                        canvasHeight = containerHeight;
                    }

                    canvas.css("width", (canvasWidth + skyward.seatingchart.canvasEdgeBuffer) + "px");
                    canvas.css("height", (canvasHeight + skyward.seatingchart.canvasEdgeBuffer) + "px");
                }
            };

            var toggleIndicators = function ()
            {
                var showIndicators = this.checked;
                var data =
                {
                    displayIndicators: showIndicators,
                    staffMeetSettingID: $(this).data("staffmeetsettingid")
                };

                $.ajax({
                    activityIndicator: { silent: true },
                    url: skyward.global.virtualDir + 'Attendance/SeatingChart/ToggleIndicators/',
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                });

                // we can still perform the toggle regardless if the staff meet setting ajax succeeded. 
                var seatingChartContent = $(this).parents(skyward.seatingchart.seatingChartContentSelector);
                setIndicatorVisibility(showIndicators, seatingChartContent);
            };

            var setIndicatorVisibility = function (show, seatingChartContent)
            {
                seatingChartContent.find(".studentIndicatorContainer").each(function ()
                {
                    if (show)
                    {
                        $(this).removeClass("displayNone");
                    }
                    else
                    {
                        $(this).addClass("displayNone");
                    }
                })

                seatingChartContent.find(".studentNameLabel").each(function ()
                {
                    var studentLabel = $(this);
                    if (!isNullOrEmpty(studentLabel) && studentLabel.data("hasactivecriticalalert") === "True")
                    {
                        if (show)
                        {
                            studentLabel.addClass("hasActiveCriticalAlert");
                        }
                        else
                        {
                            studentLabel.removeClass("hasActiveCriticalAlert");
                        }
                    }
                });

            };

            var deleteKeyName = 'delete';
            var arrowLeft = 'arrowleft';
            var arrowRight = 'arrowright';
            var arrowUp = 'arrowup';
            var arrowDown = 'arrowdown';
            var copyKey = 'keyc';
            var cutKey = 'keyx';
            var pasteKey = 'keyv';
            var selectAllKey = 'keya';
            var undoKey = 'keyz';
            var redoKey = 'keyy';

            var controlLeft = 'controlleft';
            var controlRight = 'controlright';
            var pressedKey = null;

            var copiedRoomObjects = [];

            var undoStack = [];
            var redoStack = [];

            var createAction = 'create';
            var moveAssignAction = 'moveAssign';
            var swapAssignAction = 'swapAssign';
            var moveAction = 'move';
            var deleteAction = 'delete';
            var assignAction = 'assign';
            var unassignAction = 'unassign';

            var leftClick = 1;
            var rightClick = 3;

            var hasPendingDeletesThatHaveStudents = false; 

            var roomLayoutKeyDown = function (event)
            {
                var keyName = event.code ? event.code.toLowerCase() : undefined;
                if (!isGeneralTabActive() || isPopupActive() || !keyName || !beginKeyDown(keyName))
                {
                    return;
                }

                if (event.ctrlKey)
                {
                    switch (keyName)
                    {
                        case cutKey:
                            cutSelectedRoomObjects();
                            break;
                        case copyKey:
                            copySelectedRoomObjects();
                            break;
                        case pasteKey:
                            pasteRoomObjects();
                            break;
                        case selectAllKey:
                            selectAllRoomObjects();
                            break;
                        case undoKey:
                            undo();
                            break;
                        case redoKey:
                            redo();
                            break;
                        default:
                            break;
                    }
                }
                else
                {
                    switch (keyName)
                    {
                        case deleteKeyName:
                            deleteSelectedRoomObjects(true);
                            break;
                        case arrowLeft:
                        case arrowRight:
                        case arrowUp:
                        case arrowDown:
                            arrowKeyMoveRoomObjects(keyName);
                            break;
                        default:
                            break;
                    }
                }
            };

            var seatingChartKeyDown = function (event)
            {
                var keyName = event.code.toLowerCase();
                if (!isGeneralTabActive() || isPopupActive() || !beginKeyDown(keyName))
                {
                    return;
                }

                if (event.ctrlKey)
                {
                    switch (keyName)
                    {
                        case undoKey:
                            undo();
                            break;
                        case redoKey:
                            redo();
                            break;
                        default:
                            break;
                    }
                }
            };

            var beginKeyDown = function (keyName)
            {
                preventKeyDefault(keyName, event.ctrlKey);
                if (pressedKey != null && pressedKey === keyName)
                {
                    return false;
                }

                // dont count the control keys as pressing a button
                if (keyName != controlLeft && keyName != controlRight)
                {
                    pressedKey = keyName;
                }

                return true;
            }

            var addUndoAction = function (undoAction)
            {
                redoStack.length = 0;
               
                undoStack.push(undoAction);

                setUndoRedoButton(); 
            }

            var setUndoRedoButton = function ()
            {
                var enableDisable = function (button, stack)
                {
                    if (!isNullOrEmpty(button))
                    {
                        if (stack.length > 0)
                        {
                            skyward.controls.enable(button);
                        }
                        else
                        {
                            skyward.controls.disable(button);
                        }
                    }
                };

                enableDisable(undoButton, undoStack);
                enableDisable(redoButton, redoStack);
            };

            var undo = function ()
            {
                if (undoStack.length == 0)
                {
                    return;
                }

                var action = undoStack.pop();
                var redoAction = switchAction(action);
                executeUndoRedoAction(action);
                redoStack.push(redoAction);

                if (undoStack.length == 0)
                {
                    skyward.seatingchart.setDirtyState(false);
				}

                setUndoRedoButton(); 
            };

            var redo = function ()
            {
                if (redoStack.length == 0)
                {
                    return;
                }

                var action = redoStack.pop();
                var undoAction = switchAction(action);
                executeUndoRedoAction(action);
                undoStack.push(undoAction);

                skyward.seatingchart.dirtyScreen();

                setUndoRedoButton(); 
            };

            var createMoveAction = function (roomObjects, oldPositions)
            {
                var newAction =
                {
                    action: moveAction,
                    data:
                    {
                        roomObjects: roomObjects,
                        oldPositions: oldPositions
                    }
                };

                return newAction;
            };

            var createUnassignAction = function (student, roomObject)
            {
                var newAction =
                {
                    action: unassignAction,
                    data:
                    {
                        student: student,
                        roomObject: roomObject,
                    }
                };

                return newAction;
            };

            var createSwapAssignAction = function (student, roomObject, otherStudent, otherRoomObject)
            {
                var newAction =
                {
                    action: swapAssignAction,
                    data:
                    {
                        student: student,
                        roomObject: roomObject,
                        otherStudent: otherStudent,
                        otherRoomObject: otherRoomObject
                    }
                };

                return newAction;
            };

            var createMoveAssignAction = function (student, roomObject, oldRoomObject)
            {
                var newAction =
                {
                    action: moveAssignAction,
                    data:
                    {
                        student: student,
                        roomObject: roomObject,
                        oldRoomObject: oldRoomObject,
                    }
                };

                return newAction;
            };

            var createAssignAction = function (student, roomObject, otherStudent)
            {
                var newAction =
                {
                    action: assignAction,
                    data:
                    {
                        student: student,
                        roomObject: roomObject,
                        otherStudent: otherStudent
                    }
                };

                return newAction;
            };

            var createAddAction = function (roomObjects)
            {
                var newAction =
                {
                    action: createAction,
                    data:
                    {
                        roomObjects: roomObjects,
                    }
                };

                return newAction;
            };

            var createDeleteAction = function (roomObjects)
            {
                var newAction =
                {
                    action: deleteAction,
                    data:
                    {
                        roomObjects: roomObjects,
                    }
                };

                return newAction;
            };

            var switchAction = function (undoRedoAction)
            {
                if (!undoRedoAction || !undoRedoAction.action || !undoRedoAction.data)
                {
                    return;
                }

                var action = undoRedoAction.action;
                var data = undoRedoAction.data;

                switch (action)
                {
                    case moveAction:
                        data =
                        {
                            oldPositions: getRoomObjectPositions(data.roomObjects),
                            roomObjects: data.roomObjects
                        };
                        break;
                    case deleteAction:
                        action = createAction;
                        break;
                    case createAction:
                        action = deleteAction;
                        break;
                    case moveAssignAction:
                        data =
                        {
                            student: data.student,
                            roomObject: data.oldRoomObject,
                            oldRoomObject: data.roomObject,
                        };
                        break; 
                    case swapAssignAction:
                        data =
                        {
                            student: data.student,
                            roomObject: data.otherRoomObject,
                            otherStudent: data.otherStudent,
                            otherRoomObject: data.roomObject
                        };
                        break; 
                    case assignAction:
                        if (!isNullOrEmpty(data.otherStudent))
                        {
                            data =
                            {
                                student: data.otherStudent,
                                roomObject: data.roomObject,
                                otherStudent: data.student
                            };
                        }
                        else
                        {
                            action = unassignAction;
						}
                        break;
                    case unassignAction:
                        action = assignAction;
                        break;
                    default:
                        break;
                }

                var newAction =
                {
                    action: action,
                    data: data
                }

                return newAction;
            };

            var executeUndoRedoAction = function (undoRedoAction)
            {
                if (!undoRedoAction || !undoRedoAction.action || !undoRedoAction.data)
                {
                    return;
                }

                var action = undoRedoAction.action;
                var data = undoRedoAction.data;

                switch (action)
                {
                    case moveAction:
                        $.each(data.oldPositions, function (index, oldPosition)
                        {
                            var roomObject = oldPosition.roomObject;
                            roomObject.css("left", oldPosition.xLocation + "px");
                            roomObject.css("top", oldPosition.yLocation + "px");
                        });
                        break;
                    case deleteAction:
                        $.each(data.roomObjects, function (index, roomObjectValue)
                        {
                            var roomObject = $(roomObjectValue);
                            restoreRoomObject(roomObject);
                        });
                        checkForDeletedRoomLayoutStudents();
                        break;
                    case createAction:
                        $.each(data.roomObjects, function (index, roomObjectValue)
                        {
                            var roomObject = $(roomObjectValue);
                            roomObject.addClass("roomObjectDeleted");
                            roomObject.removeClass("roomObjectPlaced");
                        });
                        checkForDeletedRoomLayoutStudents();
                        break;
                    case moveAssignAction:
                        appendStudentToSeat(data.student, data.oldRoomObject); 
                        break; 
                    case swapAssignAction:
                        appendStudentToSeat(data.student, data.otherRoomObject, true);
                        appendStudentToSeat(data.otherStudent, data.roomObject, true);
                        autoScale(); 
                        break; 
                    case assignAction:
                        if (isNullOrEmpty(data.otherStudent))
                        {
                            // then it was assigned from the list to replace a student
                            appendStudentToList(data.student);
                        }
                        else
                        {
                            // swap students on seat
                            appendStudentToList(data.student);
                            appendStudentToSeat(data.otherStudent, data.roomObject);
                        }
                        break; 
                    case unassignAction:
                        appendStudentToSeat(data.student, data.roomObject);
                        break; 
                    default:
                        break;
                }
            };

            var preventKeyDefault = function (keyName, ctrlKey)
            {
                switch (keyName)
                {
                    case deleteKeyName:
                    // prevent the arrow keys from scrolling
                    case arrowLeft:
                    case arrowRight:
                    case arrowUp:
                    case arrowDown:
                        event.preventDefault();
                        break;
                    case undoKey:
                    case redoKey:
                    case pasteKey:
                    case copyKey:
                    case selectAllKey:
                        if (ctrlKey)
                        {
                            event.preventDefault();
                        }
                        break;
                    default:
                        break;
                }
            };

            var arrowKeyMoveRoomObjects = function (keyName)
            {
                var selectedRoomObjects = getSelectedRoomObjects()

                if (!selectedRoomObjects || selectedRoomObjects.length == 0)
                {
                    return;
                }

                var moveX = 0;
                var moveY = 0;
                switch (keyName)
                {
                    case arrowLeft:
                        moveX = -gridLineSizeValueX;
                        break;
                    case arrowRight:
                        moveX = gridLineSizeValueX;
                        break;
                    case arrowUp:
                        moveY = -gridLineSizeValueY;
                        break;
                    case arrowDown:
                        moveY = gridLineSizeValueY;
                        break;
                    default:
                        break;
                }

                var oldPositions = getRoomObjectPositions(selectedRoomObjects);
                var moveAction = createMoveAction(selectedRoomObjects, oldPositions);
                addUndoAction(moveAction);

                var roomObjectsBounds = moveRoomObjects(selectedRoomObjects, moveX, moveY);

                arrowKeyAutoScroll(keyName, roomObjectsBounds);
            };

            var moveRoomObjects = function (roomObjects, moveX, moveY)
            {
                var lowestPoint = 0;
                var highestPoint = Number.MAX_VALUE;
                var rightMostPoint = 0;
                var leftMostPoint = Number.MAX_VALUE;

                var newPositions = [];
                var edgeReached = false;

                roomObjects.each(function ()
                {
                    var roomObject = $(this);
                    var newPoint = getSnapToGridPoint(parseInt(roomObject.css("left").replace("px", "")) + moveX, parseInt(roomObject.css("top").replace("px", "")) + moveY)

                    if (newPoint.xLocation + roomObject.width() > rightMostPoint)
                    {
                        rightMostPoint = newPoint.xLocation + roomObject.width();
                    }

                    if (newPoint.xLocation < leftMostPoint)
                    {
                        leftMostPoint = newPoint.xLocation;
                    }

                    if (newPoint.yLocation < highestPoint)
                    {
                        highestPoint = newPoint.yLocation;
                    }

                    if (newPoint.yLocation + roomObject.height() > lowestPoint)
                    {
                        lowestPoint = newPoint.yLocation + roomObject.height();
                    }

                    if (leftMostPoint < 0 || highestPoint < 0)
                    {
                        edgeReached = true;
                        return false;
                    }

                    newPositions.push(
                        {
                            roomObject: roomObject,
                            newXLocation: newPoint.xLocation,
                            newYLocation: newPoint.yLocation
                        })
                });

                if (!edgeReached)
                {
                    skyward.seatingchart.dirtyScreen();

                    $.each(newPositions, function (index, newPosition)
                    {
                        var roomObject = newPosition.roomObject;
                        roomObject.css("left", newPosition.newXLocation + "px");
                        roomObject.css("top", newPosition.newYLocation + "px");

                        checkExpandCanvas(roomObject);
                    })
                }

                var roomObjectsBounds =
                {
                    lowestPoint: lowestPoint,
                    highestPoint: highestPoint,
                    rightMostPoint: rightMostPoint,
                    leftMostPoint: leftMostPoint
                };

                return roomObjectsBounds;
            };

            var getRoomObjectPositions = function (roomObjects, getOriginalPositions)
            {
                if (!roomObjects || roomObjects.length == 0)
                {
                    return new Array();
                }

                var locations = [];

                $.each(roomObjects, function (index, roomObjectValue)
                {
                    var roomObject = $(roomObjectValue);
                    var xLocation;
                    var yLocation;

                    if (getOriginalPositions)
                    {
                        xLocation = parseInt(roomObject.data("originalleft"));
                        yLocation = parseInt(roomObject.data("originaltop"));
                    }
                    else
                    {
                        xLocation = parseInt(roomObject.css("left").replace("px", ""));
                        yLocation = parseInt(roomObject.css("top").replace("px", ""));
                    }
                    locations.push({
                        roomObject: roomObject,
                        xLocation: xLocation,
                        yLocation: yLocation
                    });
                });

                return locations;
            };

            var arrowKeyAutoScroll = function (keyName, roomObjectBounds)
            {
                var adjustedTop = canvasScrollContainer.scrollTop();
                var adjustedLeft = canvasScrollContainer.scrollLeft();
                var adjustedRight = adjustedLeft + canvasScrollContainer[0].clientWidth;
                var adjustedBottom = adjustedTop + canvasScrollContainer[0].clientHeight;
                var edgeBuffer = gridLineSizeValueX * skyward.seatingchart.arrowBufferCells;

                if (keyName === arrowRight && roomObjectBounds.rightMostPoint > adjustedRight - edgeBuffer)
                {
                    canvasScrollContainer.animate({ scrollLeft: adjustedLeft + edgeBuffer }, skyward.seatingchart.arrowScrollSpeed);
                }

                if (keyName === arrowLeft && adjustedLeft > 0 && roomObjectBounds.leftMostPoint < (adjustedLeft + edgeBuffer))
                {
                    canvasScrollContainer.animate({ scrollLeft: adjustedLeft - edgeBuffer }, skyward.seatingchart.arrowScrollSpeed);
                }

                if (keyName === arrowUp && adjustedTop > 0 && roomObjectBounds.highestPoint < adjustedTop + edgeBuffer)
                {
                    canvasScrollContainer.animate({ scrollTop: adjustedTop - edgeBuffer }, skyward.seatingchart.arrowScrollSpeed);
                }

                if (keyName === arrowDown && roomObjectBounds.lowestPoint > adjustedBottom - edgeBuffer)
                {
                    canvasScrollContainer.animate({ scrollTop: adjustedTop + edgeBuffer }, skyward.seatingchart.arrowScrollSpeed);
                }
            };

            var selectAllRoomObjects = function ()
            {
                selectRoomObjects(getRoomObjects());
            };

            var revertSelectedObjects = function (selectedObjects)
            {
                selectedObjects = selectedObjects || getSelectedRoomObjects(); 
                selectedObjects.each(function ()
                {
                    var currObject = $(this);
                    currObject.animate({
                        left: currObject.data("originalleft") + "px",
                        top: currObject.data("originaltop") + "px",
                    }, skyward.seatingchart.durationForRevert);
                });
            };

            var checkForDeletedRoomLayoutStudents = function ()
            {
                var deletedRoomObjects = $(".roomObjectDeleted:has(.roomObjectStudents)"); 

                hasPendingDeletesThatHaveStudents = !isNullOrEmpty(deletedRoomObjects); 

                if (!hasPendingDeletesThatHaveStudents)
                {
                    hideWarningBanner(moduleContent); 
				}
            };

            var deleteSelectedRoomObjects = function (clearSelection)
            {
                var selectedRoomObjects = getSelectedRoomObjects()

                if (!selectedRoomObjects || selectedRoomObjects.length == 0)
                {
                    return;
                }

                selectedRoomObjects.each(function ()
                {
                    var roomObject = $(this);

                    roomObject.addClass("roomObjectDeleted");
                    roomObject.removeClass("roomObjectPlaced");

                    if (clearSelection != null && clearSelection == true)
                    {
                        unselectRoomObject(roomObject);
					}
                });

                checkForDeletedRoomLayoutStudents();

                var deleteAction = createDeleteAction(selectedRoomObjects);
                addUndoAction(deleteAction);

                skyward.seatingchart.dirtyScreen();
            }

            var cutSelectedRoomObjects = function ()
            {
                var selectedRoomObjects = getSelectedRoomObjects()

                if (!selectedRoomObjects || selectedRoomObjects.length == 0)
                {
                    return;
                }

                copySelectedRoomObjects(true);

                deleteSelectedRoomObjects(true);

                unselectRoomObjects();
            };

            var copySelectedRoomObjects = function (clone)
            {
                var selectedRoomObjects = getSelectedRoomObjects()

                if (!selectedRoomObjects || selectedRoomObjects.length == 0)
                {
                    return;
                }

                copiedRoomObjects.length = 0;

                selectedRoomObjects.each(function ()
                {
                    if (clone !== true)
                    {
                        copiedRoomObjects.push($(this));
                    }
                    else
                    {
                        var newRoomObject = $(this); 
                        newRoomObject.addClass("cutRoomObject");
                        copiedRoomObjects.push(newRoomObject);
					}
                });
            };

            var pasteRoomObjects = function ()
            {
                if (copiedRoomObjects == null || copiedRoomObjects.length == 0)
                {
                    return;
                }

                var newRoomObjects = []; 

                $.each(copiedRoomObjects, function ()
                {
                    var roomObject = $(this);
                    var newRoomObject;
                    var isCut = roomObject.hasClass("cutRoomObject");

                    if (roomObject.parents().has(canvas).length > 0)
                    {
                        if (isCut)
                        {
                            newRoomObject = roomObject; 
                        }
                        else
                        {
                            newRoomObject = cloneRoomObject(roomObject, true); 
                            var pastePoint = getSnapToGridPoint((roomObject.position().left + roomObject.width() + (gridLineSizeValueX * skyward.seatingchart.pasteOffsetCells)),
                                (roomObject.position().top + roomObject.height() + (gridLineSizeValueY * skyward.seatingchart.pasteOffsetCells)));

                            newRoomObject.css("top", pastePoint.yLocation + "px");
                            newRoomObject.css("left", pastePoint.xLocation + "px");
						}
                    }
                    else
                    {
                        newRoomObject = roomObject;
					}

                    if (!isCut)
                    {
                        newRoomObject.removeAttr("data-roomlayoutobjectid");
                        newRoomObject.appendTo(canvas);

                        registerRoomObjectDraggable(newRoomObject, false, canvasObjectRevertFunction(canvas));
                        checkExpandCanvas(newRoomObject);
                    }
                    else
                    {
                        newRoomObject.removeClass("cutRoomObject");
                        restoreRoomObject(newRoomObject);
					}
                    
                    newRoomObjects.push(newRoomObject);
                });

                skyward.seatingchart.dirtyScreen();

                var creatAction = createAddAction(newRoomObjects);
                addUndoAction(creatAction);

                unselectRoomObjects();
                selectRoomObjects(newRoomObjects);

                copySelectedRoomObjects();
            };

            var restoreRoomObject = function (roomObject)
            {
                if (isNullOrEmpty(roomObject))
                {
                    return;
                }

                roomObject.removeClass("roomObjectDeleted");
                roomObject.addClass("roomObjectPlaced");
            };

            var cloneRoomObject = function (roomObject, removeRoomObjectStudents)
            {
                if (isNullOrEmpty(roomObject))
                {
                    return null; 
                }

                var newRoomObject = roomObject.clone(); 

                if (removeRoomObjectStudents === true)
                {
                    newRoomObject.find(".roomObjectStudents").remove();
                }

                return newRoomObject; 
            };

            var canvasContextMenu = function (event)
            {
                if (event.ctrlKey)
                {
                    // for devs to show the context menu
                    return true;
                }

                var clickedElement = $(event.target);

                if (!clickedElement || clickedElement.length == 0)
                {
                    return true;
                }

                if (isRoomObjectPlaced(clickedElement) || clickedElement[0] == canvas[0])
                {
                    event.preventDefault();
                    return false;
                }
            };

            var getSnapToGridPoint = function (x, y)
            {
                var point =
                {
                    xLocation: Math.round(x / gridLineSizeValueX) * gridLineSizeValueX,
                    yLocation: Math.round(y / gridLineSizeValueY) * gridLineSizeValueY
                };

                return point;
            };

            var isRoomObjectPlaced = function (roomObject)
            {
                if (roomObject && roomObject.length > 0)
                {
                    return roomObject.hasClass("roomObjectPlaced");
                }
                else
                {
                    return false;
                }
            };

            var canvasClicked = function (event)
            {
                var clickedElement = $(event.target);

                if (!clickedElement || clickedElement.length == 0)
                {
                    return;
                }

                if (isRoomLayoutDetails && !isDragging())
                {
                    if (event.ctrlKey && isRoomObjectPlaced(clickedElement))
                    {
                        if (isRoomObjectSelected(clickedElement))
                        {
                            unselectRoomObject(clickedElement);
                        }
                        else
                        {
                            selectRoomObjects({ clickedElement });
                        }
                    }
                    else
                    {
                        if (getSelectedRoomObjects().length > 1 || !isRoomObjectSelected(clickedElement))
                        {
                            unselectRoomObjects();
                            if (isRoomObjectPlaced(clickedElement))
                            {
                                selectRoomObjects(clickedElement);
                            }
                        }
                    }
                }
                else if (isSeatingChartDetails)
                {
                    if (event.which == leftClick && isRoomObjectPlaced(clickedElement) && !roomObjectHasStudent(clickedElement))
                    {
                        var firstUnassignedStudent = getFirstStudentInList();

                        if (firstUnassignedStudent && firstUnassignedStudent.length)
                        {
                            var student = firstUnassignedStudent.find(".studentImage");
                            appendStudentToSeat(student, clickedElement);

                            var assignAction = createAssignAction(student, clickedElement);
                            addUndoAction(assignAction);

                            skyward.seatingchart.dirtyScreen();
                        }
                    }
                    else if (event.which == rightClick && (clickedElement.hasClass("roomObjectHasStudent") || clickedElement.parents(".roomObjectHasStudent").length > 0) && !event.ctrlKey)
                    {
                        if (!clickedElement.hasClass("roomObjectHasStudent"))
                        {
                            clickedElement = clickedElement.parents(".roomObjectHasStudent");
                        }

                        var student = clickedElement.find(".studentImageSeated");

                        event.preventDefault();

                        if (student && student.length > 0)
                        {
                            appendStudentToList(student);

                            var unassignAction = createUnassignAction(student, clickedElement);
                            addUndoAction(unassignAction);

                            skyward.seatingchart.dirtyScreen();

                            findNextStudentForSeat(clickedElement);
                        }
                    }
                }
            };

            var checkUnassignedStudents = function ()
            {
                var firstUnassignedStudent = getFirstStudentInList();
                var hasUnassignedStudents = (firstUnassignedStudent && firstUnassignedStudent.length) == true;
                var emptySeats = canvas.find(".roomObjectPlaced:not(.roomObjectHasStudent)");

                emptySeats.each(function ()
                {
                    var emptySeat = $(this);
                    emptySeat.css("cursor", hasUnassignedStudents ? "" : "default");
                });
            };

            var roomObjectMouseEnter = function (event)
            {
                findNextStudentForSeat($(event.target));
            };

            var findNextStudentForSeat = function (roomObject)
            {
                if (!isRoomObjectPlaced(roomObject))
                {
                    return;
                }

                var firstUnassignedStudent = getFirstStudentInList();

                if (firstUnassignedStudent && firstUnassignedStudent.length)
                {
                    if (!roomObjectHasStudent(roomObject))
                    {
                        firstUnassignedStudent.addClass("assignFromStudentList");
                    }
                    else
                    {
                        // this can happen if desks are very close together
                        firstUnassignedStudent.removeClass("assignFromStudentList");
                    }
                }
            };

            var roomObjectMouseLeave = function (event)
            {
                var selectedStudents = studentList.find(".assignFromStudentList");

                selectedStudents.each(function ()
                {
                    var student = $(this);
                    student.removeClass("assignFromStudentList");
                });
            };

            var getFirstStudentInList = function ()
            {
                return studentList.find('.studentListContainer:not(.studentInSeatingChart)').first();
            };

            var roomObjectHasStudent = function (roomObject)
            {
                if (!roomObject || roomObject.length == 0)
                {
                    return false;
                }

                return roomObject.hasClass("roomObjectHasStudent");
            };

            var unselectRoomObjects = function (roomObjects)
            {
                roomObjects = roomObjects || getSelectedRoomObjects();
                roomObjects.each(function ()
                {
                    unselectRoomObject($(this));
                });
            };

            var unselectRoomObject = function (roomObject)
            {
                roomObject.removeClass("ui-selected");
            };

            var isRoomObjectSelected = function (roomObject)
            {
                if (!roomObject || roomObject.length == 0)
                {
                    return false;
                }

                return roomObject.hasClass("ui-selected");
            };

            var isDragging = function ()
            {
                return seatingChartContent.find(".ui-draggable-dragging").length > 0;
            };

            var selectRoomObjects = function (roomObjects)
            {
                if (roomObjects == null || roomObjects.length == 0)
                {
                    return;
                }

                removeErrorBorder(roomObjects);

                $.each(roomObjects, function (key, roomObjectValue)
                {
                    var roomObject = $(roomObjectValue);

                    if (!roomObject.hasClass("ui-selected"))
                    {
                        roomObject.addClass("ui-selected");
                    }
                });
            };

            var removeErrorBorder = function (roomObjects)
            {
                if (roomObjects == null || roomObjects.length == 0)
                {
                    return;
                }

                $.each(roomObjects, function (key, roomObjectValue)
                {
                    var roomObject = $(roomObjectValue);

                    if (roomObject.hasClass("roomObjectError"))
                    {
                        roomObject.removeClass("roomObjectError");
                    }
                });
            };

            var getSelectedRoomObjects = function ()
            {
                return canvas.find(".roomObject.ui-selected:not(.roomObjectDeleted)");
            };

            var getRoomObjects = function ()
            {
                return canvas.find(".roomObjectPlaced:not(.roomObjectDeleted)");
            };

            var getCanvasObjectsFromSelector = function (selector)
            {
                return canvas.find(selector); 
            }

            // Beginning Initialization Logic
            // General Variables
            var moduleContent = $("#moduleContent"); 
            var canvas = $("#roomCanvas");
            var undoButton = $("#SeatingChartUndo");
            var redoButton = $("#SeatingChartRedo");
            var canvasScrollContainer = $("#roomCanvasScrollContainer");
            var removeRoomObject = $("#removeRoomObject");
            var roomLayoutModeTab = $("#roomLayoutMode");
            var studentModeTab = $("#studentMode");
            var seatingChartData = $("#seatingChartData");
            var displayPeriodId = seatingChartData.data("displayperiodid");
            var seatingChartId = seatingChartData.data("seatingchartid");
            var roomId = seatingChartData.data("roomid");
            var roomLayoutId = seatingChartData.data("roomlayoutid");
            var saveObject = seatingChartData.data('saveobject');
            var isSeatingChartDetails = saveObject == "SeatingChart";
            var isRoomLayoutDetails = saveObject === "RoomLayout";
            var isDailyAttendance = saveObject === "DailyAttendanceBySeatingChart";
            var displayMaxSeats = isRoomLayoutDetails ? seatingChartData.data("displaymaxseats") === "True" : false;
            var maxSeats = isRoomLayoutDetails ? seatingChartData.data("maxseats") : "";
            var meetId = null;
            var studentList = $("#StudentList_body");

            if (seatingChartData.data("meetid"))
            {
                meetId = seatingChartData.data("meetid");
            }

            // Settings
            skyward.seatingchart.snapToGrid(true);
            skyward.seatingchart.gridLineSize(defaultGridLineSizeValueX, defaultGridLineSizeValueY);
            skyward.seatingchart.gridLineMaxSize = 50;
            skyward.seatingchart.gridLineResizeStep = 5;
            skyward.seatingchart.gridSnapTolerance = 10;
            skyward.seatingchart.canvasEdgeBuffer = 300; // The edge buffer is primarily to account for space lost when minimizing the Edit tabs
            skyward.seatingchart.durationForRevert = 200;
            skyward.seatingchart.distanceBeforeDragging = 10;
            skyward.seatingchart.draggingAppendTo = '#seatingChartContent';
            skyward.seatingchart.seatingChartContentSelector = '.contentArea,.skywardContentPanel';
            skyward.seatingchart.arrowScrollSpeed = 50;
            skyward.seatingchart.arrowBufferCells = 3;
            skyward.seatingchart.pasteOffsetCells = 2;

            // Screen Elements
            var seatingChartContentArea = $('#seatingChartContent');
            var saveSeatingChartButton = $("#SeatingChartSave");
            var cancelSeatingChartButton = $("#SeatingChartCancel");
            var addSeatSeatingChartButton = $("#SeatingChartAddSeats");
            var assignStudentsSeatingChartButton = $("#SeatingChartAssignStudents");
            var displayIndicators = $("#DisplayIndicators");
            var isInDetailsPanel = $(".contentArea,.skywardContentPanel").parents("#detailsPanel").length > 0;

            var gridEnableCheckbox = $("#enableGrid");
            var gridIncreaseButton = $("#GridIncrease");
            var gridDecreaseButton = $("#GridDecrease");
            var selectNewSeatingChartButton = $("#SelectNewSeatingChart");

            if (selectNewSeatingChartButton.length === 0)
            {
                skyward.seatingchart.displayPrintScreenElements(true, true);
            }

            saveSeatingChartButton.hide();
            cancelSeatingChartButton.hide();

            // DailyAttendance by SeatingChart
            // Initialize attendance colorables
            $(selector + ' .seatingChartAttendanceColorable').each(function ()
            {
                var coloredBackground = $(this);
                var updateThisColor = function ()
                {
                    skyward.dailyAttendance.updateColorable(coloredBackground, function (colorable)
                    {
                        var control = colorable.find(".seatingChartAttendanceDropdown");
                        var selectedOption;
                        if (control.length == 0)
                        {
                            control = colorable.find(".seatingChartAttendanceRadioButtonGroup");
                            var value = skyward.controls.getValue(control);
                            if (value == null || value.length == 0)
                            {
                                value = "present";
                            }
                            selectedOption = control.find("label[id^='" + value + "'].radioButton")
                        }
                        else
                        {
                            selectedOption = control.find('option:selected');
                        }

                        var teacherEntryId = selectedOption.data('teacherentryid');

                        return seatingChartData.data('teacherentrycolor' + teacherEntryId);
                    });
                };

                updateThisColor();
                coloredBackground.find('.seatingChartAttendanceDropdown,.seatingChartAttendanceRadioButtonGroup').change(updateThisColor);
            });

            if (roomLayoutModeTab)
            {
                roomLayoutModeTab.on("tabClicked", function ()
                {
                    var studentImages = $(".studentImage");
                    removeStudentDraggableEvents(studentImages);

                    registerRoomObjectDraggable($(".roomObjectList"), true, toolboxObjectRevertFunction());
                    registerRoomObjectDraggable($(".roomObjectPlaced"), false, canvasObjectRevertFunction());

                    studentImages.removeClass("seatingChartModeActive");
                    $(".roomObject").addClass("seatingChartModeActive");

                    canvas.selectable({ distance: 30 });
                });
            }

            if (studentModeTab)
            {
                studentModeTab.on("tabClicked", function ()
                {
                    var roomObjects = $(".roomObject");
                    removeRoomObjectDraggableEvents(roomObjects);

                    $(".roomObjectSeat").each(function ()
                    {
                        var roomObjectSeat = $(this);
                        if (!roomObjectSeat.data("ui-droppable"))
                        {
                            registerCanvasObjectDroppable(roomObjectSeat);
                        }
                    });

                    var studentImages = $(".studentImage");
                    registerStudentDraggable(studentImages, studentRevertFunction());

                    studentImages.addClass("seatingChartModeActive");
                    roomObjects.removeClass("seatingChartModeActive");

                    removeSelectable();
                });
            }

            unFreezeCanvas();

            canvasScrollContainer.droppable(
                {
                    accept: ".roomObject"
                });

            $("#StudentList_body").droppable(
                {
                    accept: ".studentImageSeated",
                    drop: function (event, ui)
                    {
                        var student = ui.draggable; 
                        var roomObject = $(".roomObjectPlaced").has(student);
                        var unassignAction = createUnassignAction(student, roomObject);
                        addUndoAction(unassignAction);
					}
                });

            removeRoomObject.droppable(
                {
                    accept: ".roomObjectPlaced",
                    hoverClass: "removeRoomObjectHover",
                    drop: function (event, ui)
                    {
                        var selectedRoomObjects = getSelectedRoomObjects(); 
                        deleteSelectedRoomObjects(true);
                        revertSelectedObjects(selectedRoomObjects);
                        removeRoomObject.addClass("removeRoomObjectHidden");
                    }
                });

            canvasResize();

            attachListeners();

            // Autoscale desks initially to make sure contents fit on desk
            autoScale();
        };

        var meetBrowseLoaded = function ()
        {
            var codeEEL = $(this);
            var codeEELData = codeEEL.data();

            if (codeEELData)
            {
                codeEEL.on("change", function ()
                {
                    var backingData = $(this).find(".dmsBackingData");
                    var meetsJson = JSON.stringify(skyward.controls.getValue(backingData));
                    var byPeriod = $(this).attr('id').startsWith("ByPeriod");
                    var seatingChartType = byPeriod ? "P" : "C"; 

                    var postData =
                    {
                        SeatingChartType: seatingChartType
                    };

                    if (byPeriod)
                    {
                        postData.ByPeriodMeetEEL = meetsJson;
                    }
                    else
                    {
                        postData.ByClassMeetEEL = meetsJson;
					}

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Attendance/SeatingChart/MeetsChanged",
                            type: "POST",
                            dataType: "JSON",
                            data: postData,
                            activityIndicator: { silent: true },
                            success: function (data)
                            {
                                var anchorID = byPeriod ? "ByPeriodStudentCount" : "ByClassStudentCount";
                                var anchor = $("#" + anchorID); 
                                anchor.text(data.Update[anchorID]);
                            }
                        });
                });
            }
        };

        skyward.seatingchart.openStudentPopupAddWorkFlow = function ()
        {
            var seatingChartType = $("#SeatingChartType").val();
            var meetsEEL = seatingChartType === "P" ? "#ByPeriodMeetEEL" : "#ByClassMeetEEL"; 
            
            openRoomObjectStudentPopup($(meetsEEL), "SeatingChartStudentsPopupAddWorkflow")
        };

        var roomLayoutDetailsStudentsClick = function ()
        {
            openRoomObjectStudentPopup($(this), "SeatingChartStudentsPopup");
        };

        var openRoomObjectStudentPopup = function (dataObject, action)
        {
            var data;
            var anchor;
            var afterClose;
            var modalTitle;
            if (action === "SeatingChartStudentsPopup")
            {
                modalTitle = "Students Using This Seat";
                var roomObject = dataObject.parents(".roomObjectPlaced");
                anchor = roomObject;

                if (isNullOrEmpty(roomObject))
                {
                    return;
                }
                roomObject.addClass("roomObjectHover");

                var studentSections = JSON.stringify(dataObject.data("studentsections"));
                var roomLayoutObjectID = roomObject.data("roomlayoutobjectid");
                data =
                {
                    StudentSections: studentSections,
                    RoomLayoutObjectID: roomLayoutObjectID
                };

                afterClose = function ()
                {
                    roomObject.removeClass("roomObjectHover");
                }
            }
            else if (action === "SeatingChartStudentsPopupAddWorkflow")
            {
                modalTitle = "Students";

                var backingData = dataObject.find(".dmsBackingData");
                var meetsJson = JSON.stringify(skyward.controls.getValue(backingData));

                data =
                {
                    meetIDs: meetsJson
                };
            }

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Attendance/SeatingChart/" + action,
                    type: "POST",
                    data: data,
                    dataType: "viewparthtml",
                    activityIndicator: { silent: false }
                });
            };

            var closeButton = { id: 'printClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

            var dialog = skyward.modalLayer.showDialog(modalTitle, buildPopup, [closeButton],
                {
                    draggable: true,
                    anchorTo: anchor,
                    afterClose: afterClose
                });

            $.when(dialog.bodyPromise).done(function ()
            {
                attachStudentInfoClick(dialog.content);
            });
        };

        var isNullOrEmpty = function (jObject)
        {
            return jObject == null || jObject.length == 0;
        };

        var attachStudentInfoClick = function (parent)
        {
            var studentInfoParts = parent.find(".studentImage.studentImageHasAccess,.studentInformationIndicator");
            studentInfoParts.off("click", studentInformationPopupClicked);
            studentInfoParts.on("click", studentInformationPopupClicked);
        }

        var studentInformationPopupClicked = function ()
        {
            var seatingChartContent = $(this).parents(skyward.seatingchart.seatingChartContentSelector);
            var hiddenStudentInfoButton = seatingChartContent.find("#HiddenStudentInfoButton_" + $(this).data('studentid'));
            var studentInfoParts = seatingChartContent.find(".studentImage.studentImageHasAccess");
            var studentIds = [];
            for (var i = 0; i < studentInfoParts.length; i++ )
            {
                studentIds.push(studentInfoParts[i].getAttribute("data-studentid"));
            }
            hiddenStudentInfoButton.data("student-ids", JSON.stringify(studentIds));
            hiddenStudentInfoButton.data("alternative-selected-target-id", $(this).data('studentid'));
            hiddenStudentInfoButton.data("does-not-require-browse", "true");
            hiddenStudentInfoButton.data("custom-student-seek-type", "SeatingChart"); 
            if (hiddenStudentInfoButton && hiddenStudentInfoButton.length > 0)
            {
                hiddenStudentInfoButton[0].click();
            }
        };

        skyward.seatingchart.openDailyAttendanceSettings = function ()
        {
            var staffMeetSettingID = $("#DailyAttendanceSettings").data("staffmeetsettingid");
            skyward.window.loadContent("full", "Attendance", "StaffMeetSetting", "DailyAttendanceBySeatingChartSettings", staffMeetSettingID);
		}

        skyward.seatingchart.displayPrintScreenElements = function (showElements, showMoreButton)
        {
            var printInfoLine = $(".PrintInfoLine");
            var teacherLabel = $("#TeacherLabel");
            var teacherText = $("#TeacherText");
            var sectionsLabel = $("#SectionsLabel");
            var sectionsText = $("#SectionsText");
            var periodText = $("#periodText");
            var periodLabel = $("#periodLabel");
            var roomText = $("#RoomText");
            var roomLabel = $("#RoomLabel");
            var roomLayoutLabel = $("#RoomLayoutLabel");
            var roomLayoutText = $("#RoomLayoutDescription");
            var seatingChartDescriptionText = $("#seatingChartDescription");
            var seatingChartDescriptionLabel = $("#seatingChartDescriptionLabel");
            var moreMenuSeatingChartButtons = $("#moreMenuSeatingChartButtons");

            if (showElements)
            {
                printInfoLine.css("display", "block");
                teacherLabel.css("display", "inline");
                teacherText.css("display", "inline");
                sectionsLabel.css("display", "inline");
                sectionsText.css("display", "inline");
                periodLabel.css("display", "inline");
                periodText.css("display", "inline");
                roomText.css("display", "inline");
                roomLabel.css("display", "inline");
                roomLayoutLabel.css("display", "inline");
                roomLayoutText.css("display", "inline");
                seatingChartDescriptionText.css("display", "inline");
                seatingChartDescriptionLabel.css("display", "inline");
            }
            else
            {
                sectionsLabel.css("display", "none");
                sectionsText.css("display", "none");
                roomText.css("display", "none");
                roomLabel.css("display", "none");
                roomLayoutLabel.css("display", "none");
                roomLayoutText.css("display", "none");
                seatingChartDescriptionText.css("display", "none");
                seatingChartDescriptionLabel.css("display", "none");
            }
            if (showMoreButton)
            {
                moreMenuSeatingChartButtons.css("display", "inline");
            }
            else
            {
                moreMenuSeatingChartButtons.css("display", "none");
            }
        };

        var printSeatingChart = function ()
        {
            printOptionsPopup('SeatingChart', 'PrintSeatingChart');
        };

        var printRoomLayout = function ()
        {
            printOptionsPopup('RoomLayout', 'PrintRoomLayout');
        };

        var printOptionsPopup = function (controller, printAction)
        {
            var action = "PrintOptionsPopup";
            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Attendance/" + controller + "/" + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true }
                });
            };

            var printButton = { id: 'print', text: "Print", click: function () { print(controller, printAction, dialog); dialog.close(); }, icon: "PrintAvailable" };
            var closeButton = { id: 'printClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

            var dialog = skyward.modalLayer.showDialog('Print Options', buildPopup, [printButton, closeButton]);
        };

        var print = function (controller, printAction, dialog)
        {
            var seatingChartData = $("#seatingChartData").data();
            seatingChartData.PrintFromBrowse = false;
            seatingChartData.Orientation = dialog.content.find('#orientationRadioButtonGroup.radioButtonGroupValue').val();
            seatingChartData.PortraitSize = dialog.content.find('#portraitSizeRadioButtonGroup.radioButtonGroupValue').val();

            var url = skyward.global.virtualDir + 'Attendance/' + controller + '/' + printAction;
            skyward.printScreen.launchWorkflow(url, seatingChartData);
        };

        var printFromBrowse = function ()
        {
            var button = $(this);
            var buttonData = button.data();
            var url = skyward.global.virtualDir + 'Attendance/' + buttonData.controller + '/' + buttonData.screen + '/';
            $.ajax({
                activityIndicator: { silent: true },
                url: url,
                type: "POST",
                dataType: "JSON",
                data: buttonData,
            });

            skyward.printScreen.launchWorkflow(url, buttonData);
        }

        var cloneSeatingChart = function ()
        {
            clone("SeatingChart", $(this).data());
        };

        var cloneRoomLayout = function ()
        {
            clone("RoomLayout", $(this).data());
        };

        var clone = function (cloneObjectName, workflowData)
        {
            skyward.window.loadContent("popup", "workflow", "workflowinstance", "Create/Attendance/" + cloneObjectName + "/Clone", null, workflowData, null);
		}

        var seatingChartLegend = function ()
        {
            var saveObject = $("#seatingChartData").data("saveobject");
            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Attendance/" + saveObject + "/BuildLegend",
                    activityIndicator: { silent: true },
                    type: "POST",
                    dataType: "viewparthtml"
                });
            };

            var options =
            {
                draggable: true,
                anchorTo: $(this)
            };

            var modal = skyward.modalLayer.showDialog((saveObject === "SeatingChart" ? "Seating Chart" : "Room Layout") + " Legend", buildPopup, { text: "Close", icon: "Close" }, options);
            modal.container.css("min-width", "200px");
        };

        skyward.window.registerLoadDOMCallback(init);

        skyward.events.registerEvents("seatingchart",
        {
            "showLegend" : seatingChartLegend,
            "print": printSeatingChart,
            "clone": cloneSeatingChart,
            "printRoomLayout": printRoomLayout,
            "cloneRoomLayout": cloneRoomLayout,
            "meetBrowseLoaded": meetBrowseLoaded,
            "printFromBrowse": printFromBrowse
        });

    }(window.skyward = window.skyward || {}, window.jQuery)
);